// src/pages/AuthCallback.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');

      if (!code) {
        alert('No authorization code received.');
        return;
      }

      try {
        const response = await fetch(`${AQ_BASE_URL}/aq/api/google/callback`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, state }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          alert(errorData.message || 'OAuth failed');
          return;
        }

        const data = await response.json();

        // Save tokens to localStorage or cookie
        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);

        // Navigate to dashboard or any other route
        navigate('/dashboard');
      } catch (error) {
        console.error('OAuth callback error:', error);
      }
    };

    handleOAuthCallback();
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      <p className="text-gray-700 font-medium">Signing you in...</p>
    </div>
  );
};

export default AuthCallback;
